export default {
  msgManageApi: {
    createTokenBySId: '/appSupport/h5Case/getBaseInfoBySId',
    getSign: '/appSupport/h5Case/getSign',
    updateSign: '/appSupport/h5Case/updateSign',
    saveFileParams: '/appSupport/h5Case/saveFileParams',
    satisfactionCase: '/appSupport/h5Case/satisfactionCase'
  }
}